module.exports = __webpack_public_path__ + "static/media/projects_image - Shortcut.234e8d66.lnk";